// extracted by mini-css-extract-plugin
export var colorSquare = "_om-0";
export var danger = "_om-5";
export var lightPink = "_om-8";
export var neutralBlue = "_om-7";
export var neutralYellow = "_om-6";
export var normal = "_om-1";
export var primary = "_om-2";
export var primaryLight = "_om-3";
export var solidBlack = "_om-g";
export var solidGreen = "_om-b";
export var solidLightBlue = "_om-d";
export var solidNavy = "_om-c";
export var solidOrange = "_om-f";
export var solidPink = "_om-e";
export var solidRed = "_om-9";
export var solidYellow = "_om-a";
export var success = "_om-4";